import React from "react";
import styled from "styled-components";

import { VoteStatus } from "types/voteEnum";

import BasicProposalButton from "components/vote/Quizzbox/common/Buttons/BasicProposalButton";
import ProposalsGroup from "components/vote/Quizzbox/common/ProposalsGroup";

type Props = {
    titleId: string;
    options: Array<{ id: string; text: string }>;
    answers: Array<string | undefined>;
    index: number;
    setVoteStatus: React.Dispatch<React.SetStateAction<VoteStatus>>;
    setAnswers: React.Dispatch<React.SetStateAction<Array<string | undefined>>>;
    disabledOptions: string[];
    closeAccordion?: () => void;
    isLocked: boolean;
};

const OptionsWrapper = ({
    titleId,
    options,
    answers,
    index,
    setAnswers,
    setVoteStatus,
    disabledOptions,
    closeAccordion,
    isLocked,
}: Props) => {
    const renderOptions = () => {
        return options.map((option) => {
            const isActive = answers[index - 1] === option.id;
            const isDisabled = isLocked || disabledOptions.includes(option.id);

            const onClickProposal = () => {
                if (isDisabled) {
                    return;
                }

                const newAnswers = [...answers];
                if (isActive) {
                    newAnswers[index - 1] = undefined;
                    setAnswers(newAnswers);
                    setVoteStatus(VoteStatus.Idle);
                    return;
                }

                newAnswers[index - 1] = option.id;
                setAnswers(newAnswers);
                if (closeAccordion) {
                    closeAccordion();
                }
            };

            return (
                <BasicProposalButton
                    key={option.id}
                    text={option.text}
                    isActive={isActive}
                    onClick={onClickProposal}
                    isDisabled={isDisabled}
                />
            );
        });
    };

    // One answer per sub-question
    return (
        <Wrapper titleId={titleId} maxNumberOfAnswers={1}>
            {renderOptions()}
        </Wrapper>
    );
};

const Wrapper = styled(ProposalsGroup)`
    margin-top: 15px;
`;

export default OptionsWrapper;
